module.exports = __webpack_public_path__ + "img/rcgysq.d87b8cf0.png";